const targetElements = document.querySelectorAll('.js-set-variant');
const update_new_val = (target, value) => {
  const targetElement = document.querySelectorAll(target);
  for (let i = 0; i < targetElement.length; i++) {
    targetElement[i].innerText = value;
  }
}

const updateInfo = () => {

  setTimeout(() => {

    selected_variant = JSON.parse(sessionStorage.getItem('variant2shopify'));

    if (selected_variant && selected_variant.sku) {
      update_new_val('.js-new-sku', selected_variant.sku);
    }

    if (selected_variant && selected_variant.option1) {
      update_new_val('.js-new-size', selected_variant.option1.split(' ')[0]);
    }

    if (selected_variant && selected_variant.option2) {
      update_new_val('.js-new-color', selected_variant.option2);
    }

    if (selected_variant && selected_variant.option3) {
      update_new_val('.js-new-finish', selected_variant.option3);
    }

    if (selected_variant && selected_variant.option1) {
      update_new_val('.js-new-shape', selected_variant.option1.split(' ')[1]);
    }

  }, 1000)

}

if (targetElements && targetElements.length > 0) {
  targetElements.forEach(element => element.addEventListener("click", updateInfo))
}


document.addEventListener('DOMContentLoaded', () => {

  if (!document.body.classList.contains('template-product-tiles')) {
    return;
  }

  function updateGalleryImages(selectedColor) {
    const galleryImages = document.querySelectorAll('.js-thumb-item-img');
    galleryImages.forEach((img) => {

      const imageAlt = img.getAttribute('alt') || '';
      const container = img.closest('.js-thumb-item');

      if (imageAlt.includes(`Color | ${selectedColor}`)) {
        container.style.display = 'block';
      } else if (imageAlt.includes('Color |')) {
        container.style.display = 'none';
      } else {
        container.style.display = 'block';
      }

    });
  }

  // Initialize gallery based on the initially selected variant
  function initializeGallery() {
    const initialSelected = document.querySelector('input[name="color"]:checked');
    if (initialSelected) {
      const selectedColor = initialSelected.value;
      updateGalleryImages(selectedColor);
    }
  }

  // Listen for changes to variant swatches
  function attachVariantChangeListener() {
    const swatchInputs = document.querySelectorAll('input[name="color"]');
    swatchInputs.forEach((input) => {
      input.addEventListener('change', (event) => {
        const selectedColor = event.target.value;
        updateGalleryImages(selectedColor);
      });
    });
  }

  // Initialize script
  initializeGallery();
  attachVariantChangeListener();
});

const getProductPrice = () => {
  // const pricePerPiece = //document.querySelector(".price-item").innerHTML
  const pricePerPiece = product_price_token / 100;
  // let numericPrice = pricePerPiece.replace('$', '');
  // numericPrice = numericPrice.replace('\n', '');
  return Number(pricePerPiece);
}

const getTotalSizeRequired = () => {
  const sqft = document.getElementById('Sqft').value;
  const overageInput = document.getElementById('overagePercentage');
  const overage = parseInt(overageInput.value || 0) / 100;
  const totalSqftReq = sqft * (1 + overage);
  return Number(totalSqftReq);
}

const getIsItemSoldByBox = () => {
  const value = (myProductVariable && myProductVariable.soldByFullBox && (myProductVariable.soldByFullBox === 'Yes' || myProductVariable.soldByFullBox === 'yes')) ? true : false;
  return value;
}

const getSizeOfaProductInSqFt = () => { 
  const value = document.querySelector('.js-new-sqt-pr-box').innerHTML.trim();
  const number = isNaN(value) || value === "" ? 0 : Number(value);
  
  return number;
}

const getPiecesInABox = () => {
  const value = document.querySelector('.js-new-Pieces-Per-Box').innerHTML.trim();
  const number = isNaN(value) || value === "" ? 0 : Number(value);
  
  return number;
  
}

const getSheetSize = () => {
  const sheetSizeArr = (myProductVariable && myProductVariable.sheetSize) ? myProductVariable.sheetSize.split('x') : [];
  number = 0;
  if(sheetSizeArr.length === 2){
    number = Number(((sheetSizeArr[0] * sheetSizeArr[1]) / 144).toFixed(2));
  }
  return number;
}

const getTileSize = () => {
  const tileSize = document.querySelector('.js-new-size').innerHTML;
  const tileSizeArr = (tileSize) ? tileSize.split('x') : [];
  number = 0;
  if(tileSizeArr.length === 2){
    number = Number(((tileSizeArr[0] * tileSizeArr[1]) / 144).toFixed(2));
  }
  return number;
}

const identifyCategoryOfProduct = () => {

  const isItemSoldByBox = getIsItemSoldByBox();
  const sizeOfaProductInSqFt = getSizeOfaProductInSqFt();
  const piecesInABox = getPiecesInABox();
  const productPrice = getProductPrice();
  const tileSize = getTileSize();
  const sheetSize = getSheetSize();

  arr = [];
  
  if(myProductVariable.display_custom_price){
    arr[0] = 0;
    arr[1] = myProductVariable.display_price;
  } else if (isItemSoldByBox) {
    arr[0] = 1;
    arr[1] = productPrice / sizeOfaProductInSqFt;
  } else if (sizeOfaProductInSqFt > 1 && piecesInABox > 0) {
    arr[0] = 2;
    arr[1] = piecesInABox / sizeOfaProductInSqFt * productPrice;
  } else if (sizeOfaProductInSqFt === 0 && piecesInABox > 1){
    arr[0] = 3;
    arr[1] = productPrice;
  } else if (tileSize === 0 && sheetSize > 0 && sizeOfaProductInSqFt === 0)  {
    arr[0] = 4;
    arr[1] = 1 / sheetSize * productPrice;
  } else if ((tileSize >= 0.1 && tileSize != 0.17) && sizeOfaProductInSqFt === 0)  {
    arr[0] = 5;
    arr[1] = productPrice / tileSize;
  } else if ((tileSize < 0.1 || tileSize === 0.17) && sizeOfaProductInSqFt === 0)  {
    arr[0] = 6;
    arr[1] = productPrice;
  } else {
    arr[0] = 6;
    arr[1] = productPrice;
  }
  return arr;

}

ProductPriceElement = document.getElementById('js-product-price');

if(ProductPriceElement){
  productCatogory = identifyCategoryOfProduct()
  ProductPriceElement.innerHTML = '$'+productCatogory[1].toFixed(2);

  let printStatus = document.getElementsByClassName("prio")[0];

  if (productCatogory[0] === 3 || productCatogory[0] === 6) {
    printStatus.innerHTML = "Price per sq ft";
  } else if (productCatogory[0] === 0 && myProductVariable.display_price_in_sq_ft) {
    printStatus.innerHTML = "Price per sq ft";
  } else  {
    printStatus.innerHTML = "Price per piece";
  }
  
}

function convertToSquareFeet(input) {

  const cleanInput = input.trim().replace(/\s+/g, '');
  const match = cleanInput.match(/^([\d.]+)x([\d.]+)$/i);
  
  if (!match) {
      throw new Error("Invalid format. Use format like '14.5x11.5'");
  }

  const length = parseFloat(match[1]);
  const width = parseFloat(match[2]);

  const areaInInches = length * width;
  const areaInSquareFeet = areaInInches / 144;

  return {
      inches: areaInInches,
      squareFeet: areaInSquareFeet
  };
}


const productSizePerBox = (category_id) => {
  // const sqt_pr_box = (myProductVariable && myProductVariable.soldByFullBox && (myProductVariable.soldByFullBox === 'Yes' || myProductVariable.soldByFullBox === 'yes')) ? document.querySelector('.js-new-sqt-pr-box').innerHTML : 1;

  if(category_id === 1){
    return document.querySelector('.js-new-sqt-pr-box').innerHTML;
  } else if(category_id === 2){
    return document.querySelector('.js-new-sqt-pr-box').innerHTML / document.querySelector('.js-new-Pieces-Per-Box').innerHTML;
  } else if(category_id === 5){
    return convertToSquareFeet(document.querySelector('.js-new-size').innerHTML).squareFeet;
  } else if(category_id === 4){
    return convertToSquareFeet(myProductVariable.sheetSize).squareFeet;
  } else if(category_id === 0) {
    const sqFt = convertToSquareFeet(document.querySelector('.js-new-size').innerHTML).squareFeet;
    return (sqFt > 0.1) ? sqFt : 1;

  } else {
    return 1;
  }

}

const roundToQuarter = value => {
  const num = value.toFixed(2).split('.');
  const first_number = num[0]
  const second_number = Math.ceil(num[1] / 25) * 25;
  return first_number + '.' + parseInt(second_number.toString().slice(0, 2));
}

const roundToDecimal = value => {
  const num = value.toFixed(2).split('.');
  const first_number = num[0]
  const second_number = Math.ceil(num[1]);
  return first_number + '.' + second_number;
}

const updateText = (category_id) => {
  
  
  switch(category_id) {
    
    case 3:
    document.getElementById('totalSqftText').textContent = 'Total Linear Feet: ';
    document.querySelectorAll('.calculator label[for="Sqft"]')[0].innerHTML = 'Linear ft needed';
    break;
    case 6:
    document.getElementById('totalSqftText').textContent = 'Total Linear Feet: ';
    document.querySelectorAll('.calculator label[for="Sqft"]')[0].innerHTML = 'Linear ft needed';
    break;
    
    default:
    document.getElementById('totalSqftText').textContent = 'Total sq ft: ';
    document.querySelectorAll('.calculator label[for="Sqft"]')[0].innerHTML = 'Sq ft needed';
    
  }

  switch(category_id) {
    
    case 0:
    document.getElementById('numBoxesText').textContent = 'Number of Units: ';
    break;
    case 2:
    document.getElementById('numBoxesText').textContent = 'Number of Units: ';
    break;
    case 3:
    document.getElementById('numBoxesText').textContent = 'Number of Units: ';
    break;
    case 4:
    document.getElementById('numBoxesText').textContent = 'Number of Units: ';
    break;
    case 5:
    document.getElementById('numBoxesText').textContent = 'Number of Units: ';
    break;
    case 6:
    document.getElementById('numBoxesText').textContent = 'Number of Units: ';
    break;
    
    default:
    document.getElementById('numBoxesText').textContent = 'Number of boxes: ';

  }

}


function calculateResults() {

  const productCatogory = identifyCategoryOfProduct();
  const sqtFeetPerBox = Number(productSizePerBox(productCatogory[0]));
  const pricePerBox = getProductPrice();
  const totalSizeRequired = getTotalSizeRequired();
  
  
  var numOfBoxesReq = Math.ceil(totalSizeRequired / +sqtFeetPerBox);
  
  let totalPrice;
  if(productCatogory[0] === 2 || productCatogory[0] === 5 || productCatogory[0] === 6){
    document.getElementById('numBoxes').textContent = Math.ceil(numOfBoxesReq);
  } else {
    document.getElementById('numBoxes').textContent = Math.ceil(numOfBoxesReq);
  }
  
  if(productCatogory[0] === 2 || productCatogory[0] === 3 || productCatogory[0] === 4 || productCatogory[0] === 5 || productCatogory[0] === 6 || productCatogory[0] === 0){
    document.getElementById('totalSqft').textContent = totalSizeRequired.toFixed(2);
    totalPrice = Number(numOfBoxesReq * pricePerBox).toFixed(2);
    
  } else {
    document.getElementById('totalSqft').textContent = roundToDecimal(numOfBoxesReq * sqtFeetPerBox);
    totalPrice = roundToQuarter(numOfBoxesReq * pricePerBox);
  }
  

  document.getElementById('totalSqftByUser').textContent = totalSizeRequired.toFixed(2);
  document.querySelectorAll('[name="quantity"]')[0].value = Math.ceil(numOfBoxesReq);
  document.getElementById('totalPrice').textContent = `$${totalPrice}`;
  
  
  
  updateText(productCatogory[0]);

  
}

document.addEventListener("DOMContentLoaded", function () {

  let btnDecrease = document.getElementById('btn-decrease');
  let btnIncrease = document.getElementById('btn-increase');

  let btnOverageDecrease = document.querySelector('#overagePercentageCounter .btn-decrease');
  let btnOverageIncrease = document.querySelector('#overagePercentageCounter .btn-increase');

  if (document.getElementById('Sqft')) {
    calculateResults();
  }

  if (btnDecrease) {
    btnDecrease.addEventListener('click', function () {
      document.getElementById('Sqft').value = +document.getElementById('Sqft').value - 1;
      calculateResults();
      if (document.getElementById('Sqft').value < 1) {
        btnDecrease.disabled = true;
      } else {
        btnDecrease.disabled = false;
      }
    });
  }

  if (btnIncrease) {
    btnIncrease.addEventListener('click', function () {
      document.getElementById('Sqft').value = +document.getElementById('Sqft').value + 1;
      calculateResults();
      if (document.getElementById('Sqft').value < 1) {
        btnDecrease.disabled = true;
      } else {
        btnDecrease.disabled = false;
      }
    });
  }

  if (btnOverageDecrease) {
    btnOverageDecrease.addEventListener('click', function () {
      document.getElementById('overagePercentage').value = +document.getElementById('overagePercentage').value - 1;
      calculateResults();
      if (document.getElementById('overagePercentage').value < 1) {
        btnOverageDecrease.disabled = true;
      } else {
        btnOverageDecrease.disabled = false;
      }
      if (document.getElementById('overagePercentage').value >= 20) {
        btnOverageIncrease.disabled = true;
      } else {
        btnOverageIncrease.disabled = false;
      }
    });
  }

  if (btnOverageIncrease) {
    btnOverageIncrease.addEventListener('click', function () {
      document.getElementById('overagePercentage').value = +document.getElementById('overagePercentage').value + 1;
      calculateResults();
      if (document.getElementById('overagePercentage').value < 1) {
        btnOverageDecrease.disabled = true;
      } else {
        btnOverageDecrease.disabled = false;
      }
      if (document.getElementById('overagePercentage').value >= 20) {
        btnOverageIncrease.disabled = true;
      } else {
        btnOverageIncrease.disabled = false;
      }
    });
  }






});


// Event listeners for Sqft and overage inputs

if (document.getElementById('Sqft')) {
  document.getElementById('Sqft').addEventListener('input', calculateResults);
}
if (document.getElementById('overagePercentage')) {
  document.getElementById('overagePercentage').addEventListener('input', calculateResults);
}





  document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('template-product-tiles')) {
      return;
    }
    
    productCatogory = identifyCategoryOfProduct()
  
    let printStatus = document.getElementsByClassName("prio")[0];
  
    if (productCatogory[0] !== 3 && productCatogory[0] !== 6) {
      printStatus.innerHTML = "Price per sq ft";
    } else if (productCatogory[0] === 0 && myProductVariable.display_price_in_sq_ft) {
      printStatus.innerHTML = "Price per sq ft";
    } else  {
      printStatus.innerHTML = "Price per piece";
    }
    

});
















